export default {
  state: () => ({
    forumIds: {
      memberId: 0,
      userId: 0,
      groupId: 0,
    },
    appList: [],
    appListWithAppLink: [],
    pcList: [],

    // 是否已經取得tabs所需的資料
    isGetTabsData: {
      forumIds: false,
      appList: false,
      appListWithAppLink: false,
      pcList: false,
    },
  }),
  getters: {
    forumIds(state) {
      return state.forumIds;
    },
    appList(state) {
      return state.appList;
    },
    appListWithAppLink(state) {
      return state.appListWithAppLink;
    },
    pcList(state) {
      return state.pcList;
    },
    isGetTabsData(state) {
      return state.isGetTabsData;
    },
  },
  mutations: {
    UPDATE_FORUMIDS(state, payload) {
      state.forumIds = payload.forumIds;
    },
    UPDATE_APP_LIST(state, payload) {
      state.appList = payload.appList;
    },
    UPDATE_APP_LIST_WITH_APP_LINK(state, payload) {
      state.appListWithAppLink = payload.appListWithAppLink;
    },
    UPDATE_PC_LIST(state, payload) {
      state.pcList = payload.pcList;
    },
    UPDATE_IS_GET_TABS_DATA(state, payload) {
      state.isGetTabsData[payload.option] = payload.data;
    },
  },
  actions: {
    updateForumIds({ commit }, payload) {
      commit('UPDATE_FORUMIDS', payload);
    },
    updateAppList({ commit }, payload) {
      commit('UPDATE_APP_LIST', payload);
    },
    updateAppListWithAppLink({ commit }, payload) {
      commit('UPDATE_APP_LIST_WITH_APP_LINK', payload);
    },
    updatePcList({ commit }, payload) {
      commit('UPDATE_PC_LIST', payload);
    },
    updateIsGetTabsData({ commit }, payload) {
      commit('UPDATE_IS_GET_TABS_DATA', payload);
    },
  },
};
